import { createSlice, PayloadAction, createAsyncThunk, AsyncThunkPayloadCreator } from '@reduxjs/toolkit'
import { AxiosRequestConfig } from 'axios';
import { App } from '../../interfaces/Org';
import { SliceStatus } from '../../interfaces/Redux';
import { get } from '../../services/http'
import routeListen from '../../services/routeListen';

export interface orgState {
  orgExists: boolean
  apps: App[],
  status: SliceStatus,
  error?: string | undefined
}

const initialState: orgState = {
  orgExists: false,
  apps: [],
  status: SliceStatus.idle,
  error: ''
}

export const orgSlice = createSlice({
  name: 'org',
  initialState,
  reducers: {
    logout: () => {
      return initialState
    },
    setOrgExists: (state) => {
      state.orgExists = true;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchOrg.pending, (state, action) => {
        state.status = SliceStatus.loading
        state.error = undefined
      })
      .addCase(fetchOrg.fulfilled, (state, action) => {
        if(action.payload) {
          state.orgExists = true
          state.status = SliceStatus.succeeded
          // Add any fetched posts to the array
          state.apps = action.payload.apps
          state.error = undefined
        }
        
      })
      .addCase(fetchOrg.rejected, (state, action) => {
        state.orgExists = false
        state.status = SliceStatus.failed
        state.error = action.error.message
      })
  }
})

export const fetchOrg = createAsyncThunk('library/fetchLibrary', async () => {

  const config:AxiosRequestConfig = {
    headers: {
      organization: routeListen.shortName()
    }
  }

  const response = await get(`/api/library`, config)
  .catch((response) => {
    throw new Error(response.message);
  });
  return response.data
});

// Action creators are generated for each case reducer function
export const { logout, setOrgExists } =  orgSlice.actions


export default orgSlice.reducer


